module.exports = __webpack_public_path__ + "static/img/4112331.ed94cb3.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/4112331.svg
// module id = bqSL
// module chunks = 1